import type { Company } from '../types';

export const parseIncomeData = (company: Partial<Company>): Company =>
  ({
    ...company,
    email: company.email === '' ? null : company.email,
    address: Array.isArray(company.address) ? {} : company.address,
    groups: (company.groups || []).map((group: any) => group.name),
    representatives: (company.representatives || []).map((r: any) =>
      typeof r === 'string' ? r : r.value,
    ),
    contractor: company.contractor || false,
    contrator: company.contractor || false,
  }) as Company;
